<div class="container">
  <img src="assets/images/logo-color.png" alt="purelatte-logo">
  <h1 class="404-title">{{'AUTH_ERROR.TITLE' | i18next}}</h1>
  <h3 *ngIf="errorMessage.length > 0">{{errorMessage | i18next}}</h3>
  <h3>{{'AUTH_ERROR.MESSAGE' | i18next}}</h3>
</div>

